/**
 * @class ProductGalleryModal
 * @classdesc A modal for rendering the product gallery
 *
 * @extends Core.Component
 */
export default class ProductGalleryModal extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.content = this.el.querySelector('[data-product-gallery-modal-content]');
    this.closeBtn = this.el.querySelector('[data-product-gallery-modal-close]');
  }

  /**
   * Opens the gallery modal
   * @public
   */
  open(mediaId = null) {
    this.el.classList.add('product-gallery-modal--visible');
    Core.Utils.scrollLock(this.el, this.content);

    const mediaItem = this.el.querySelector(`.product-gallery-modal__media-item[data-media="${mediaId}"]`);

    if (mediaItem) {
      mediaItem.classList.add('product-gallery-modal__media-item--selected');
      mediaItem.scrollIntoView({ behavior: 'smooth' });
    }

    this.escEvent = this.events.register(window, 'keydown', e => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.close();
      }
    });

    this.closeBtnEvent = this.events.register(this.closeBtn, 'click', () => this.close());
  }

  /**
   * Closes the gallery modal
   * @public
   */
  close() {
    const mediaItems = this.el.querySelectorAll('.product-gallery-modal__media-item');
    this.events.unregister(this.escEvent);
    this.events.unregister(this.closeBtnEvent);
    this.el.classList.remove('product-gallery-modal--visible');
    mediaItems.forEach(mediaItem => mediaItem.classList.remove('product-gallery-modal__media-item--selected'));
    Core.Utils.scrollUnlock(this.el);
  }
}
